import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { CroppedImage } from 'src/app/_models/Common/croped-image';
import { EventDetailsModelResponse, UpdateEventModelRequest } from 'src/app/_models/Event/EventModel';
import { Operations } from 'src/app/_models/Operations/Operations';
import { ApiService } from 'src/app/_services/api.service';
import { AuthService } from 'src/app/_services/auth.service';
import {
  CropAndCompressImageDialogComponent
} from '../crop-and-compress-image-dialog/crop-and-compress-image-dialog.component';
import { EventCapacityDialogComponent } from '../event-capacity-dialog/event-capacity-dialog.component';
import { SearchEventModel } from "../../_models/Event/SearchEventModel";
import { EventStatusEnum } from "../../_models/Enums/EventStatusEnum";
import { EventStatusTabMapping } from "../../_models/Constants/EventStatusTabMapping";

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss']
})
export class EventDetailsComponent implements OnInit {
  //#region Fields
  operationRead: number = Operations.Read;
  operationEdit: number = Operations.Edit;
  loadingPage: Boolean = false;
  eventIdForReservation: string;
  private routeSub: Subscription;

  startTime: string;
  eventDetails: EventDetailsModelResponse = new EventDetailsModelResponse();
  operation: number = Operations.Read;

  maxChars = 40;
  eventname = '';
  chars = 0;

  description1maxChars = 600;
  description1 = '';

  venueId: string = '';
  venueMaxCapacity: number = 0;
  venuesList: any;

  //this is for the component only populaitng in edit, read operations from the dropdown
  capacity: number = 0;
  eventDetailForm: UntypedFormGroup = new UntypedFormGroup({});
  submitted = false;
  pictureUrl: string | ArrayBuffer = './assets/images/logo/Event-Cover-Placeholder.png';
  eventTypeList: any[];
  eventPanelOpenState = true;

  minDate: any;
  eventSearchModel: SearchEventModel = new SearchEventModel();
  navigateToTab: number;

  public errorModel: { [k: string]: any } = {};
  public pastDateTimeErrorMessage = "INFO.DATE_TIME_PAST";
  //#endregion
  //#region Constructor
  constructor(
    private apiService: ApiService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    public dialogService: DialogService,
    public translate: TranslateService,
    private snackBar: MatSnackBar,
    private authService: AuthService
  ) {
    this.eventTypeList = [
      { name: 'Music & Dance', id: 1 },
      // { name:'Theatre & Performance', id: 2 },
      // { name:'Art & Craft', id: 3 },
      // { name:'Film & Photography',id: 4 },
      { name: 'Nutrition & Cuisine', id: 5 },
      // { name:'Health & Wellness', id: 6 },
      // { name:'Games & Entertainment', id: 7 },
      // { name:'Society & Lifestyle', id: 8 },
      // { name:'Design & Fashion', id: 9 },
      // { name:'Literature & Publishing', id: 10 },
      // { name:'Media & Publicity', id: 11 },
      // { name:'Business & Politics', id: 12 },
    ]
    this.authService.hideNavigationMenuEventEmitter.emit(true);
    this.minDate = new Date();
  }

  ngOnInit(): void {
    this.getEventIdForReservation();
    this.apiService.getEventDetails(this.eventIdForReservation).subscribe(
      (response) => {
        this.fetchVenues(response.id);
        this.setEventDetails(response);
      }
    );
    this.initCreateEventForm();
    // this.operation = Operations.Read;
  }
  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }
  //#endregion
  //#region Public Methods
  fetchVenues(venueId: string) {
    this.apiService.listVenuesForCombo().subscribe((result) => {
      this.venuesList = result;
    });
  }
  onEventFormSubmit(): void {
    this.submitted = true;
    if (this.eventDetailForm.invalid) {
      return;
    }
    const datepipe: DatePipe = new DatePipe('en-US')
    let datetime1 = new Date(this.eventDetailForm.value.starTTime);
    let timeonly1 = datepipe.transform(datetime1, 'HH:mm:ss');
    let date1 = datepipe.transform(this.eventDetailForm.value.eventDate, 'yyyy-MM-dd');
    let formattedStartDate = new Date(date1 + "T" + timeonly1);
    let datetime2 = new Date(this.eventDetailForm.value.endTime);
    let timeonly2 = datepipe.transform(datetime2, 'HH:mm:ss');
    let formattedEndDate = new Date(date1 + "T" + timeonly2)
    formattedEndDate = this.compareDates(formattedStartDate, formattedEndDate);
    let eventModel: UpdateEventModelRequest = {};
    eventModel.Id = this.eventIdForReservation;
    eventModel.Name = this.eventDetailForm.value.eventName;
    eventModel.Title = this.eventDetailForm.value.eventName;
    eventModel.Description = this.eventDetailForm.value.eventDescription;
    eventModel.StartDateTime = new Date(formattedStartDate).toISOString();
    eventModel.StartTime = timeonly1 as string;
    eventModel.EndDateTime = new Date(formattedEndDate).toISOString();
    eventModel.EventTypesIds = this.eventDetailForm.value.eventTypes;
    eventModel.VenueId = this.eventDetailForm.value.venue;
    eventModel.MaxCapacity = this.capacity;
    eventModel.PictureUrl = this.eventDetailForm.controls['eventImagePath'].value;

    let dateTimeNow = new Date();
    if (dateTimeNow > formattedStartDate) {
      this.errorModel['pastdatetime'] = this.pastDateTimeErrorMessage;
    } else {
      this.errorModel['pastdatetime'] = null;
    }

    if (!this.errorModel['pastdatetime']) {
      this.loadingPage = true;
      this.apiService.updateEvent(eventModel).subscribe(() => {
        this.saveChanges();
        this.loadingPage = false;
      },
        (error) => {
          this.loadingPage = false;
          this.snackBar.open('Error', 'Cancel', {
            duration: 3000
          });
        }
      );
    }
  }

  editEvent(): void {
    this.operation = Operations.Edit;
    this.enableCreateEventForm();
  }

  CancelEdit(): void {
    this.operation = Operations.Read;
    this.errorModel['pastdatetime'] = null;
    this.disableCreateEventForm();
  }

  saveChanges(): void {
    this.loadingPage = true;
    this.operation = Operations.Read;
    this.disableCreateEventForm();
    this.loadingPage = false;
  }

  PublishEvent(): void {
    let navigateToTab = Object.keys(EventStatusTabMapping)
      .find(key => EventStatusTabMapping[+key] === EventStatusEnum.Published);
    let dateTimeNow = new Date();
    if (dateTimeNow > this.eventDetails.startDateTime) {
      this.errorModel['pastdatetime'] = this.pastDateTimeErrorMessage;
    } else {
      this.errorModel['pastdatetime'] = null;
    }
    if (!this.errorModel['pastdatetime']) {
      this.loadingPage = true;
      this.apiService.publishEvent(this.eventIdForReservation).subscribe(() => {
        this.loadingPage = false;
        this.router.navigate(["/promoter/events"], { queryParams: { activeIndex: navigateToTab } });
      }, (error) => {
        this.loadingPage = false;
        this.snackBar.open(error.error.Message, 'Cancel', {
          duration: 3000
        });
      });
    }
  }

  CancelEvent(): void {
    this.loadingPage = true;
    this.apiService.cancelEvent(this.eventIdForReservation).subscribe(() => {
      this.loadingPage = false;
      this.router.navigate(["/promoter/events"], { queryParams: { activeIndex: this.navigateToTab } });
    }, (error) => {
      this.loadingPage = false;
      this.snackBar.open('Error', 'Cancel', {
        duration: 3000
      });
    });
  }
  openCapacity() {
    if (!this.venueId) {
      this.venuesList.map((venue: any) => {
        if (venue.id == this.eventDetails.venueId) {
          this.venueMaxCapacity = venue.maximumCapacity;
        }
      })
    } else {
      this.venuesList.map((venue: any) => {
        if (venue.id == this.venueId) {
          this.venueMaxCapacity = venue.maximumCapacity;
        }
      })
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'custom-modal';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      venueId: this.venueId,
      venueMaxCapacity: this.venueMaxCapacity,
      venueCapacity: this.capacity
    };
    const dialogRef = this.dialog.open(EventCapacityDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.capacity = data;
      }
    });
  }

  selectedVenue(item: any) {
    if (item != this.eventDetails.venueId) {
      this.venuesList.map((venue: any) => {
        if (venue.id == item) {
          this.venueId = item;
          this.capacity = this.venueMaxCapacity = venue.maximumCapacity;
        }
      })
    } else {
      this.capacity = this.venueMaxCapacity = this.eventDetails.maximumCapacity;
    }
    if (item == null) {
      this.venueId = "";
      this.venueMaxCapacity = 0;
    }
  }

  cropAndCompressImageDialog() {
    const ref = this.dialogService.open(CropAndCompressImageDialogComponent, {
      data: {
        imagePath: this.pictureUrl
      },
      autoZIndex: false,
      header: this.translate.instant('PREVIEW'),
      width: '960px',
      contentStyle: { "overflow-y": "auto" },
    });
    ref.onClose.subscribe((image: CroppedImage) => {
      if (image) {
        this.eventDetailForm.get('eventImagePath')?.setValue(image.imageFile);
        this.pictureUrl = image.imagePath;
      }
    });
  }

  get eventFormControls() {
    return this.eventDetailForm.controls;
  }
  //#endregion
  //#Private Methods
  private initCreateEventForm() {
    this.eventDetailForm = new UntypedFormGroup({
      eventName: new UntypedFormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(40)]),
      eventDescription: new UntypedFormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(600)]),
      eventDate: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      eventTime: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      starTTime: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      endTime: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      eventTypes: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      venue: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      eventImagePath: new UntypedFormControl(''),
    });
  }

  private setEventDetails(eventDetails: EventDetailsModelResponse) {
    this.eventDetails = eventDetails;
    this.startTime = this.parseFromTwentyFourToAmPm(this.eventDetails?.startTime)
    if (this.eventDetails.pictureUrl != "") {
      this.pictureUrl = this.eventDetails.pictureUrl as string;
    }
    const datepipe: DatePipe = new DatePipe('en-US')
    //z for local timezone
    let date = new Date((this.eventDetails.startDateTime as string) + "Z");
    let endDate = new Date((this.eventDetails.endDateTime as string) + "Z");

    this.eventDetails.startDateTime = date;
    this.eventDetails.endDateTime = endDate;
    this.capacity = this.venueMaxCapacity = eventDetails.expected as number;
    this.eventDetailForm.patchValue({ eventName: eventDetails.name });
    this.eventDetailForm.patchValue({ eventDescription: eventDetails.description });
    this.eventDetailForm.patchValue({ eventDate: eventDetails.startDateTime });
    this.eventDetailForm.patchValue({ eventTime: eventDetails.startTime });
    this.eventDetailForm.patchValue({ starTTime: eventDetails.startDateTime });
    this.eventDetailForm.patchValue({ endTime: eventDetails.endDateTime });
    this.eventDetailForm.patchValue({ eventTypes: eventDetails.eventTypeIds });
    this.eventDetailForm.patchValue({ venue: eventDetails.venueId });
    const status = this.eventDetails.status ? EventStatusEnum[this.eventDetails.status as keyof typeof EventStatusEnum] : 0;
    this.eventSearchModel.status = status;
    let navigateToTab = Object.keys(EventStatusTabMapping)
      .find(key => EventStatusTabMapping[+key] === status);
    this.navigateToTab = navigateToTab ? +navigateToTab : 0;
  }


  private compareDates(formattedStartDate: any, formattedEndDate: any) {
    let startTime = formattedStartDate.getUTCHours() + ":" + formattedStartDate.getUTCMinutes();
    let endTime = formattedEndDate.getUTCHours() + ":" + formattedEndDate.getUTCMinutes();
    if (startTime == endTime) {
      //next day
      formattedEndDate.setDate(formattedEndDate.getDate() + 1);
      return formattedEndDate;
    }
    if (formattedStartDate.getTime() < formattedEndDate.getTime()) {
      //do nothing
      return formattedEndDate;
    }
    if (formattedStartDate.getTime() >= formattedEndDate.getTime()) {
      //next day
      formattedEndDate.setDate(formattedEndDate.getDate() + 1);
      return formattedEndDate;
    }
  }

  private enableCreateEventForm() {
    this.eventDetailForm.enable();
  }

  private disableCreateEventForm() {
    this.eventDetailForm.reset();
    this.apiService.getEventDetails(this.eventIdForReservation).subscribe(
      (response) => {
        this.setEventDetails(response);
      }
    );
    this.eventDetailForm.disable();
  }

  private getEventIdForReservation() {
    this.routeSub = this.route.params.subscribe(params => {
      this.eventIdForReservation = params['id'];
    });
  }
  private parseFromTwentyFourToAmPm(time: any): string {
    const H = +time.substr(0, 2);
    const h = H % 12 || 12;
    const ampm = (H < 12 || H === 24) ? "AM" : "PM";
    time = h + time.substr(2, 3) + ' ' + ampm;
    return time;
  }
  //#endregion
}